module.exports = __webpack_public_path__ + "img/28_56.292bcd36.png";